<template>

    <div>

        <!-- Attendee Count -->
        <h4>
            <i class="fas fa-users"></i>
            <span style="margin-left: 6px;" class="event-registered-count" v-text="this.attendees.length"></span> 
        </h4>

        <!-- AltLan Registration Status -->
        <div v-if="event.type =='altlan'">
            <p v-if="this.registered == true">You have a ticket for this event!</p>
            <div>
                <button v-if="this.registered == false" style="margin-right: 6px;" type="button" class="btn btn-warning"><a href="/shop/tickets"><i class="fas fa-ticket-alt"></i> Get Tickets</a></button>
                <button type="button" class="btn btn-warning">
                    <a href="/altlan"> More Info</a>
                </button>
            </div>
        </div>

        <!-- Other Registration Status -->
        <div class="flex-x" v-else>
            <div class="flex-x" style="align-items: center;">
                <i v-show="this.request == true" id="loading-spinner" class="fa-2x fas fa-spinner fa-spin"></i>
                <button v-show="this.request == false" v-if="this.registered == true" type="button" class="btn btn-warning event-signup-button" @click="this.ToggleRegistration()"><i class="fas fa-user-minus"></i> Cancel Sign Up</button>
                <button v-show="this.request == false" v-else type="button" class="btn btn-warning event-signup-button" @click="this.ToggleRegistration()"><i class="fas fa-user-plus"></i> Sign Up</button>
            </div>
            <button v-if="this.showattendees == false" style="margin-left: 6px;" type="button" class="btn btn-warning">
                <a :href="`/event/${ event.slug }`"> More Info</a>
            </button>
        </div>

        <!-- Attendee List -->
        <div v-if="this.showattendees == true" class="attendees-list container-fluid" style="margin-bottom: 20px; margin-top: 20px; padding: 0px;">
            <div v-for="attendee in this.attendees" class="col-md-3 col-lg-2 col-xl-2 col-sm-6 col-xs-6 user-signup flex-x" style="border: 1px solid #ffc107; box-shadow: 2px 2px; padding: 6px; background: black; align-items: center; margin-right: 6px;">
                <img class="img-fluid rounded me-2" style="width: 48px;" :src="`https://cdn.discordapp.com/avatars/${ attendee.id }/${ attendee.avatar }.webp`" alt="Profile Picture">
                <p class="clip-text-1 event-username">{{ attendee.username }}#{{ attendee.discriminator }}</p>
            </div>
        </div>

    </div>

</template>

<script>

export default {

    data () {
        return {
            request: false,
            registered: false,
            count: 0,
            attendees: []
        }
    },

    props: ['event', 'userid', 'showattendees'],

    created () {
        this.count = this.event.attendees.length;

        this.attendees = this.event.attendees;

        if ( this.event.attendees.find(a => a.id == this.userid) ) this.registered = true;

        window.Echo.channel('channel-name').listen('UserRegisteredForEvent', (e) => {
            this.attendees.push(e.user);
        }).listen('UserUnregisteredForEvent', (e) => {
            const key = this.attendees.findIndex(a => a.id == e.user.id);
            this.attendees.splice(key, 1);
        });
    },

    methods: {

        Update () {
            this.count = this.event.attendees.length;
        },

        ToggleRegistration () {
            if ( this.userid == null ) ErrorToast("You are not logged in");
            this.request = true;
            axios.post('/event/register', {
                id: this.event.id, 
                registered: this.registered
            }).then( (response) => {
                this.request = false;
                this.count = response.data.count;
                this.registered = response.data.registered;

                if ( response.data.registered ) {
                    this.attendees.push(response.data.user);
                } else {
                    const key = this.attendees.findIndex(a => a.id == response.data.user.id);
                    this.attendees.splice(key, 1);
                }

            });
            
        }
    }

}
</script>